import Vue from "vue";
import {
	extend,
	ValidationObserver,
	ValidationProvider,
} from "vee-validate";
import {
	email,
	max,
	min,
	numeric,
	required,
} from "vee-validate/dist/rules";

extend("email", email);
extend("max", max);
extend("min", min);
extend("numeric", numeric);
extend("required", required);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
extend("json", value => {
	try {
		return !!JSON.parse(value);
	} catch (e) {
		return "This field must be a valid json";
	}
});
extend("min_value", (value,a) => {
	return value >= a[0] ? true:`הערך חייב להיות שווה או מעל ${a[0]}`;
});
